// src/features/universalsearcher/universalsearcherSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchResults: [], // Initialize as an empty array
};

const universalsearcherSlice = createSlice({
  name: 'universalsearcher',
  initialState,
  reducers: {
    setSearchResults: (state, action) => {
      state.searchResults = action.payload; // Replace the entire array
    },
    resetSearchResults: (state) => {
      state.searchResults = []; // Reset to an empty array
    },
  },
});

// Export actions
export const { setSearchResults, resetSearchResults } = universalsearcherSlice.actions;

// Export reducer
export default universalsearcherSlice.reducer;
